import vuetify from './vuetify';
import router from './router';
import langLinks from './langLinks';
import closable from './closable';
import bookPlayer from './book-player';
import { createHead } from '@unhead/vue/client';
import type { App } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export function registerPlugins(app: App) {
    const pinia = createPinia().use(piniaPluginPersistedstate);
    app.use(vuetify).use(router).use(pinia).use(createHead());
    langLinks(app);
    closable(app);
    bookPlayer(app);
}
